import { useLocation } from "@entry/navigation";

import { AddressConfirmationFormValues, AddressForm } from "@components/AddressForm";
import { Loader } from "@components/Loader";
import { useAddressDetails, useOnboarding, useSetUserIdentity } from "@hooks";
import { ResidentialAddressConfirmationRouteProps } from "./types";

export const ResidentialAddressConfirmationRoute = () => {
  const location = useLocation();

  const placeId = (location.state as ResidentialAddressConfirmationRouteProps).placeId;

  const { data, loading } = useAddressDetails({ placeId });
  const [setUserIdentity] = useSetUserIdentity();

  const { resetToNext } = useOnboarding();

  const handleSubmit = async (values: AddressConfirmationFormValues) => {
    await setUserIdentity({
      variables: {
        address: {
          street: values.address,
          unitNo: values.address2,
          city: values.city,
          state: values.state,
          postalCode: values.zipCode,
          country: values.country,
        },
      },
    });

    resetToNext();
  };

  if (loading) return <Loader />;

  return <AddressForm data={data} onSubmit={handleSubmit} />;
};
